import styled from '@emotion/styled';

export const SadaSettings = styled.div``;
